module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_footer_aqua-acdfe930de57297a7d637841deea3a52.svg";